export type CompanionStyle = 'girlfriend' | 'boyfriend' | 'friend' | 'open'

export function normalizeCompanionStyle(value?: string | null): CompanionStyle {
  if (value === 'girlfriend' || value === 'boyfriend' || value === 'friend') {
    return value
  }
  return 'open'
}
